import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_STATUS,
  COLUMN_TYPE,
  COLUMN_BUSINESS_PARTNERS,
  COLUMN_AFFILIATES,
  COLUMN_REG_PLATFORMS,
  COLUMN_EVENT,
  COLUMN_APPLICATIONS,
  COLUMN_CREATED_BY,
  COLUMN_LAST_UPDATED,
  COLUMN_CREATED,
  COLUMN_ACTIVITY_TYPE,
  COLUMN_TRAFFIC_TYPE,
} from 'scenes/Integrations/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_STATUS,
    COLUMN_TYPE,
    COLUMN_BUSINESS_PARTNERS,
    COLUMN_AFFILIATES,
    COLUMN_REG_PLATFORMS,
    COLUMN_EVENT,
    COLUMN_APPLICATIONS,
    COLUMN_TRAFFIC_TYPE,
    COLUMN_ACTIVITY_TYPE,
    COLUMN_CREATED_BY,
    COLUMN_LAST_UPDATED,
    COLUMN_CREATED,
  ]),
  collapsed: array(string()).default([]),
});
